export default __webpack_public_path__ + "static/media/logo_bw.9c7bd6a6.svg";